// extracted by mini-css-extract-plugin
module.exports = {"markdown":"_752nJ3"};